/**
 * Wrapper pour fournir le contexte institutionnel (établissement + année académique)
 *
 * Ce composant DOIT être rendu à l'intérieur du Router car InstitutionalProvider
 * utilise useLocation() et useSearchParams() pour lire les query params de l'URL.
 */

import { Outlet } from 'react-router-dom';
import { InstitutionalProvider } from '@sphere/shared/context/institutional';
import { useAccessStore } from '@sphere/auth/data-access';
import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

export function InstitutionalWrapper() {
  const bootstrapLoaded = useAccessStore((state) => state.bootstrapLoaded);
  const isAdmin = useAccessStore((state) => state.isAdmin());

  // Récupérer les establishmentIds directement avec shallow comparison
  // pour éviter les re-renders quand scope change de référence mais pas de valeur
  const establishmentIds = useAccessStore(
    useShallow((state) => state.scope?.establishmentIds)
  );

  // Memoize la valeur pour garantir une référence stable
  const stableEstablishmentIds = useMemo(() => {
    if (!bootstrapLoaded) return undefined;
    if (isAdmin) return null;
    return establishmentIds ?? [];
  }, [bootstrapLoaded, isAdmin, establishmentIds?.join(',')]);

  return (
    <InstitutionalProvider
      userEstablishmentIds={stableEstablishmentIds}
      scopeReady={bootstrapLoaded}
    >
      <Outlet />
    </InstitutionalProvider>
  );
}
